import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useSelector } from "react-redux";
import { formatingHeadersMerz } from "../redux/helpersHeadersPerProyect";


const ItemDowloadCSVSimiAR = ({ title, icon, disabled = true }) => {
    const { proyectSelected,arrayDataCombined } = useSelector(state => state.vrlSlice)
    const { arrayData } = useSelector(state => state.table)
    let dataDateFormated = arrayDataCombined.map((user) => ({
        ...user, Fecha_y_hora: new Date(user.Fecha_y_hora).toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }),
        Completado: user.puntaje ?  user.puntaje === "100/100" ? "Completado" : "Incompleto" : "No iniciado"
    }));
    const { typeAdmin } = useSelector((state) => state.auth)
    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });
    const [headers, setHeaders] = useState()
    useEffect(() => {
        const headersw = formatingHeadersMerz(responses).filter(header => header.dataIndex !== "Detalles")
        headersw.push({
        dataIndex: "Completado",
        label: "Completado",
        key: "Completado",
        title: "Completado",
        width: 150,
    });
        setHeaders(headersw)

    }, [responses])

    return (
        <Tooltip placement="leftTop" title={<span>{title}</span>} color="#FFFFFF" overlayInnerStyle={{ color: "#3366FF" }}>
            <button
                disabled={disabled}
                className={`${disabled ? 'bg-[#9A9A9A]' : 'bg-3366FF'} cursor-pointer flex justify-center items-center w-[32px] h-[32px] rounded-md mb-[16px]`}>
                <CSVLink data={dataDateFormated} headers={headers} filename={`export_${proyectSelected.name}.csv`}>
                    {icon}
                </CSVLink></button>

        </Tooltip>
    );
};

export default ItemDowloadCSVSimiAR;
